// @flow strict

import * as React from 'react';
import classnames from 'classnames';
import { Link } from '../../../../../internal/Button';
import type { AnalyticsType } from '../../../../../internal/types';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './styles.scss';

type LinkVariants =
  | 'MenuLinkNoChildren'
  | 'CategoryLinkNoChildren'
  | 'Link'
  | 'LoginLink'
  | 'Button';

type ButtonVariants = 'BackMenu' | 'MenuLink' | 'CategoryLink' | 'BackCategory';

export type Variants = LinkVariants | ButtonVariants;

type PropTypes =
  | {|
      children: string,
      variant: LinkVariants,
      href: string,
      analyticsEvent?: AnalyticsType,
    |}
  | {|
      children: string,
      variant: ButtonVariants,
      onClick: () => void,
      analyticsEvent?: AnalyticsType,
    |};

export default (props: PropTypes) => {
  if (props.variant === 'Button') {
    return (
      <Link
        href={props.href}
        className={styles.isButton}
        size="Small"
        analyticsEvent={props.analyticsEvent}
      >
        {props.children}
      </Link>
    );
  }

  if (props.variant === 'Link') {
    return (
      <Link
        href={props.href}
        variant="SubtleLink"
        className={styles.isLink}
        analyticsEvent={props.analyticsEvent}
      >
        {props.children}
      </Link>
    );
  }

  const classes = classnames(styles.navButton, styles[`is${props.variant}`]);

  const attributes: { [string]: string } = {
    className: classes,
  };

  if (props.onClick) {
    return (
      // $FlowFixMe
      <button onClick={props.onClick} {...attributes}>
        <span>{props.children}</span>
      </button>
    );
  }

  return (
    // $FlowFixMe
    <a href={props.href} {...attributes}>
      <span>{props.children}</span>
    </a>
  );
};
